/**
 * If the type of window is undefined, then we're not in the browser, so return false. Otherwise,
 * return true.
 * @returns a boolean value.
 */
export const checkIsBrowser = () => {
  return typeof window !== 'undefined';
};
